<template>
  <div class="noticeTargetSetting">
    <setting-header />
    <header>
      <custom-check v-model="allSelected" @input="handleSelectAll"
        >一括選択
      </custom-check>
    </header>
    <v-divider class="noticeTargetSetting_divider" />
    <main class="noticeTargetSetting_content">
      <section class="noticeTargetSetting_left">
        <section v-if="loading" class="noticeTargetSetting_loading">
          <v-progress-circular
            :size="30"
            :width="2"
            indeterminate
          ></v-progress-circular>
        </section>
        <template v-for="(item, index) in items">
          <custom-check
            :key="`check-${index}`"
            v-model="selectedTarget[item.index]"
            @input="handleSelectTarget"
            >{{ item.name }}
          </custom-check>
        </template>
      </section>
    </main>
  </div>
</template>

<script>
import CustomCheck from '@/components/inputs/CustomCheck.vue';
import SettingHeader from '../SettingHeader.vue';
import { mapActions, mapState } from 'vuex';
import isEqual from 'fast-deep-equal';
export default {
  name: 'NoticeTargetSetting',
  components: {
    SettingHeader,
    CustomCheck,
  },
  beforeRouteLeave: async function (to, from, next) {
    if (to.name !== 'settings-notice-main' || !this.isChanged) {
      // only update when is edit mode and user navigating to settings-notice-main page and there is a change

      next();
      return;
    }
    await this.updateNoticeSettings();
    this.init();
    next();
  },
  data() {
    return {
      selectedTarget: {},
      oldSelectedTarget: {},
      displayCam: null,
      allSelected: false,
    };
  },
  computed: {
    ...mapState({
      noticeSettings: (state) => state.settings.noticeSettings,
      noticeSettingsLoading: (state) => state.settings.noticeSettingsLoading,
    }),
    target() {
      return this.noticeSettings.target;
    },
    isChanged() {
      return !isEqual(this.selectedTarget, this.oldSelectedTarget);
    },
    items() {
      return this.noticeSettings.groups.map((g, index) => ({
        ...g,
        index: String(index + 1),
      }));
    },
    loading() {
      return this.noticeSettingsLoading;
    },
  },
  watch: {
    selectedTarget: {
      handler: function () {
        this.changeTarget();
      },
      deep: true,
    },
  },
  mounted() {
    this.target.forEach((selected, index) => {
      this.$set(this.selectedTarget, String(index + 1), selected);
    });
    this.init();
  },
  methods: {
    ...mapActions('settings', ['setNoticeSetting', 'updateNoticeSettings']),
    async init() {
      Object.keys(this.selectedTarget).forEach((key) => {
        this.$set(this.oldSelectedTarget, key, this.selectedTarget[key]);
      });
    },
    changeTarget() {
      const newSelectedTarget = Object.keys(this.selectedTarget).map(
        (key) => !!this.selectedTarget[key]
      );
      this.setNoticeSetting({ key: 'target', value: newSelectedTarget });
    },
    handleSelectTarget() {
      this.allSelected = Object.values(this.selectedTarget).every(
        (selected) => selected
      );
    },
    handleSelectAll(selected) {
      this.items.forEach((cam) => {
        this.$set(this.selectedTarget, cam.index, selected);
      });
    },
  },
};
</script>

<style lang="scss">
.noticeTargetSetting {
  &_conent {
    position: relative;
  }
  position: relative;
  &_loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    background-color: #ffffffab;
    z-index: 1;
  }
  &_divider {
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  header {
    margin-top: 14px;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-end;

    h5 {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #999;
    }
    .customCheck {
      margin-left: 10px;
      .customCheck_label {
        margin-left: 15px;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        width: 400px;
      }
    }
  }
  main {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  &_left {
    width: 100%;
    max-height: calc(100vh - 260px);
    overflow: auto;
    position: relative;
    .customCheck {
      padding: 12px 10px;

      border-bottom: 1px solid #eee;

      .customCheck_label {
        width: 400px;
        margin-left: 15px;
      }
    }
  }
}
</style>
